<template>
    <div class="content">
        <el-form ref="searchForm" :inline="true" :model="searchForm">
            <el-form-item>
                <el-button type="primary" @click="showAddNewTemplateDialog(null)">新 增</el-button>
                <el-button type="primary" @click="getSmsTemplateListHandler()">刷 新</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611" style="width: 100%">
            <el-table-column label="序号" type="index" width="50">
            </el-table-column>
            <el-table-column prop="tplName" label="模板标题" width="180"></el-table-column>
            <el-table-column prop="content" label="模板内容" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showAddNewTemplateDialog(scope.row)">编 辑</el-button>
                    <el-button type="text" size="small" @click="deleteTemplateAction(scope.row.id)">删 除</el-button>
                </template>    
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog :title="title" :visible.sync="addTemplateVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="template" :model="template" :rules="newTemplateFormRules" label-width="120px">
                <el-form-item label="模板标题：" prop="title">
                    <el-input v-model.trim="template.tplName" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="模板内容：" prop="content">
                    <el-input
                        type="textarea"
                        :rows="7"
                        placeholder="请输入内容"
                        v-model.trim="template.content">
                    </el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addNewSmsTemplateHandel">确 定</el-button>
            </div>   
        </el-dialog>

    </div>     
</template>

<script>
import {getSmsTemplateList, addSmsTemplat, updateSmsTemplat, deleteSmsTemplate} from '@/api/sms.js'
import common from '@/utils/common.js'
export default {
    data(){   
        return {
            searchForm: {

            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            templateId: '',

            title: '',
            template:{
                id:'',
                tplName: '',
                content: '',
            },

            newTemplateFormRules: {
                tplName: [{required: true, message: '请输入标题', trigger: 'blur'}],
                content: [{required: true, message: '请输入内容', trigger: 'blur'}]
            },

            addTemplateVisible: false,//新增或编辑短信模板对话框

            
        }
    },
    methods: {
        getSmsTemplateListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            this.searchForm.agentId = localStorage.getItem('id');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm); 
            getSmsTemplateList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        addNewSmsTemplateHandel(){
            let data = this.template; 
            data.agentId = localStorage.getItem('id');    
            if(this.template.id == null){
                addSmsTemplat(data).then(res => {
                    if(res.data.code == 200){
                        this.getSmsTemplateListHandler();
                        this.$message.success(res.data.message);
                        this.cancel();
                    }else{
                        this.$message.error(res.data.message)
                    }   
                })
            } else{
                updateSmsTemplat(data).then(res => {
                    if(res.data.code == 200){
                        this.getSmsTemplateListHandler();
                        this.$message.success(res.data.message);
                        this.cancel();
                    }else{
                        this.$message.error(res.data.message)
                    }   
                })
            }      
            
        },

        cancel(){
            this.template.id = null;
            this.template.tplName = '';
            this.template.content = '';
            this.addTemplateVisible = false;
        },

        showAddNewTemplateDialog(row){
            if(row==null){
                this.title = "新增短信模板";
                this.template.id = null;
            }else{
                this.title = "编辑短信模板";
                this.template.tplName=row.tplName;
                this.template.content=row.content;
                this.template.id = row.id;
            }

            console.log(this.template)
            this.addTemplateVisible = true;
        },


        deleteTemplateAction(id){
            this.templateId = id;
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteSmsTemplate({id: this.templateId}).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getSmsTemplateListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {

            });
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSmsTemplateListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getSmsTemplateListHandler();
        }       
    },
    created () {
        this.getSmsTemplateListHandler();
    }
}
</script>

<style lang="scss" scoped>



</style>

